import React, { useEffect, useState } from "react";
import useStore from "../../store";
import { useParams } from "react-router-dom";

const Notification = () => {
  const { notifications } = useStore();
  const { id } = useParams();
  const notification = notifications.find((n) => n.id === parseInt(id));

  const [_, setIsNotificationRendered] = useState(false);
  useEffect(() => {
    setIsNotificationRendered(true);
  }, [id]);

  return <div>{notification.notification}</div>;
};

export default Notification;
